import React from 'react';
import 'intersection-observer';
import { Barcode } from './layout/Barcode';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { appConfig } from '../../config';
// import shirtImg from '../../images/silhouette/shirt.jpg';
// Icons.
import { FaComment, FaSearch } from 'react-icons/fa';
// const baseUrl = process.env.NODE_ENV === 'production' ? '/' : 'http://aws.molohub.com/';
// const baseUrl = process.env.NODE_ENV === 'production' ? '/' : 'http://b2b.molo.com/media/';
var ProductListItem = function (props) {
    var product = props.product, quantityLabel = props.quantityLabel, showQuantity = props.showQuantity, showSoldQuantity = props.showSoldQuantity, showBarcode = props.showBarcode, baseUrl = props.baseUrl, handleShowStyleOrders = props.handleShowStyleOrders;
    var seasonCode = product.seasonCode, masterId = product.masterId, colorCode = product.colorCode;
    var imageUrl = baseUrl + 'productimage/' + seasonCode + '/' + masterId + '/' + colorCode + '/small?cache=10052021';
    quantityLabel = quantityLabel || 'Quantity';
    var getQuantity = function () {
        var master = product;
        var totalDisp = master.totalDisp || 0;
        if (props.quantityOveride) {
            return props.quantityOveride;
        }
        return totalDisp !== 9999 ? (totalDisp <= 0 ? 'Sold Out' : totalDisp) : (React.createElement("span", { className: "infiniteAvailability" }));
    };
    return (React.createElement("div", { className: "pl-item" + (props.inBasket && product.discontinued ? " in-basketdiscontinued" : (props.inBasket ? " in-basket" : "") + (product.discontinued ? " discontinued" : "")) },
        (product.b2BMasterComment || product.b2BColorComment || product.styleNote || product.colorNote) && React.createElement("span", { className: "pl-item__comment-icon" },
            React.createElement(FaComment, null)),
        React.createElement(LazyLoadImage, { alt: product.description, placeholder: React.createElement("div", { className: "pl-item__image fade-in-up" }), className: "pl-item__image fade-in-up", src: imageUrl, visibleByDefault: false, placeholderSrc: '' }),
        React.createElement("p", { className: "pl-item__text" },
            React.createElement("span", { className: "--highlighted" }, product.description),
            " ",
            product.colorName),
        React.createElement("p", { className: "pl-item__text" },
            product.masterId,
            " ",
            product.colorCode),
        props.getPrice && React.createElement("p", { className: "pl-item__text --italic" }, props.getPrice(product)),
        showBarcode && React.createElement(Barcode, { value: product.masterId }),
        showQuantity && product.colorBlocked !== 1 &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", null,
                    quantityLabel,
                    ": ",
                    getQuantity())),
        showSoldQuantity &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", { style: { color: "green" }, onClick: function (e) { return props.handleShowStyleOrders && props.handleShowStyleOrders(e, product); } },
                    React.createElement(FaSearch, null),
                    " ",
                    product.totalcolorsold),
                "/",
                product.qtysbbaskets + product.qtyb2bbaskets,
                "  ",
                product.totalmastersold),
        showQuantity && product.colorBlocked === 1 &&
            React.createElement("p", { className: "pl-item__text" },
                React.createElement("strong", null, "Blocked"))));
};
export default ProductListItem;
//# sourceMappingURL=ProductListItem.js.map